import { useEffect, useState } from "react";
import { useAreaData, useGetDepartmentDashboard, useGetDetailDashboard, usePoliceStationData, useZoneData } from "../../API_Master/GetAPI";
import DashboardMapPreview from "./DashboardMapPreview";
import Cookies from "js-cookie";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import DashboardShimmer from "../../Components/DashboardShimmer";
import { useNavigate } from "react-router-dom";
import { mainRouteInitial } from "../../Data/Constant";

const ComplianceDashboard = () => {
  const navigate = useNavigate();
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState(null); // "noCCTV" | "noAgreement" | "lateClose"

  const [filterData, setFilterData] = useState({
    cityID: Cookies.get("NIGHT_EYE_CITY_ID") || "",
    zoneID: Cookies.get("NIGHT_EYE_ZONE_ID") || "",
    policeStationID: Cookies.get("NIGHT_EYE_POLICE_STATION_ID") || "",
    areaID: Cookies.get("NIGHT_EYE_AREA_ID") || "",
    startDate: new Date(),
  });

  // const isCityLogin = Cookies.get("DP_NIGHT_EYE_USER_ROLE") === "cityuser";
  // const isZoneLogin = Cookies.get("DP_NIGHT_EYE_USER_ROLE") === "zoneuser";
  // const isPSLogin = Cookies.get("DP_NIGHT_EYE_USER_ROLE") === "policestationuser";
  const isCityLogin = true;
  const isZoneLogin = true;
  const isPSLogin = true;

  const { data: departmentDashboardData = [], isLoading, refetch } = useGetDepartmentDashboard(filterData);
  const { data: detailDashboardData = [] } = useGetDetailDashboard(filterData, modalType);
  const { data: zoneData = [] } = useZoneData(filterData?.cityID, Cookies.get("NIGHT_EYE_ZONE_ID"));
  const { data: policeStationData = [] } = usePoliceStationData(filterData?.cityID, filterData.zoneID, Cookies.get("NIGHT_EYE_POLICE_STATION_ID"));
  const { data: areaData = [] } = useAreaData(filterData?.cityID, filterData.zoneID, filterData?.policeStationID, Cookies.get("NIGHT_EYE_AREA_ID"));

  const zoneOptions =
    zoneData?.map((ele) => ({
      value: ele?.ZoneID,
      label: ele?.ZoneName,
    })) || [];

  const policeStationOptions =
    policeStationData?.map((ele) => ({
      value: ele?.PoliceStationID,
      label: ele?.PoliceStation,
    })) || [];

  const areaOptions =
    areaData?.map((ele) => ({
      value: ele?.AreaID,
      label: ele?.AreaName,
    })) || [];

  useEffect(() => {
    if (isZoneLogin && zoneOptions.length === 1) {
      setFilterData((prev) => ({
        ...prev,
        zoneID: zoneOptions[0].value || "",
      }));
    } else if (isPSLogin && policeStationOptions.length === 1) {
      setFilterData((prev) => ({
        ...prev,
        policeStationID: policeStationOptions[0].value || "",
      }));
    }
  }, []);

  const selectStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "44px",
      backgroundColor: "white",
      borderColor: state.isFocused ? "#3b82f6" : "#cbd5e1",
      borderRadius: "0.75rem",
      boxShadow: state.isFocused ? "0 0 0 3px rgba(59, 130, 246, 0.15)" : "none",
      "&:hover": { borderColor: "#9ca3af" },
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "2px 14px",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#1e293b",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#9ca3af",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "0.75rem",
      marginTop: 4,
      boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1)",
    }),
  };

  const handleSelectFilterData = (name, value) => {
    if (name === "zoneID") {
      setFilterData((prev) => ({
        ...prev,
        [name]: value,
        policeStationID: Cookies.get("NIGHT_EYE_POLICE_STATION_ID") || "",
        areaID: Cookies.get("NIGHT_EYE_AREA_ID") || "",
      }));
    } else if (name === "policeStationID") {
      setFilterData((prev) => ({
        ...prev,
        [name]: value,
        areaID: Cookies.get("NIGHT_EYE_AREA_ID") || "",
      }));
    } else {
      setFilterData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleReset = () => {
    setFilterData({
      cityID: Cookies.get("NIGHT_EYE_CITY_ID") || "",
      zoneID: Cookies.get("NIGHT_EYE_ZONE_ID") || "",
      policeStationID: Cookies.get("NIGHT_EYE_POLICE_STATION_ID") || "",
      areaID: Cookies.get("NIGHT_EYE_AREA_ID") || "",
      startDate: new Date(),
    });
  };

  // Modal Component
  const DetailModal = ({ isOpen, onClose, title, icon, color, items = [], emptyMessage = "No records found" }) => {
    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
        <div className="relative w-full max-w-5xl bg-white dark:bg-slate-900 rounded-2xl shadow-2xl  transform transition-all">
          {/* Header */}
          <div className={`px-6 py-5 flex items-center justify-between border-b ${color}`}>
            <div className="flex items-center gap-3">
              <span className={`material-symbols-outlined text-3xl ${color.replace("bg-", "text-").replace("-50", "-600").replace("-950", "-400")}`}>{icon}</span>
              <h2 className="text-xl font-bold text-slate-900 dark:text-white">{title}</h2>
            </div>
            <button onClick={onClose} className="p-2 rounded-full hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-600 dark:text-slate-300">
              <span className="material-symbols-outlined text-2xl">close</span>
            </button>
          </div>

          {/* Body */}
          <div className="max-h-[70vh] overflow-y-auto p-6">
            {items?.length === 0 ? (
              <div className="flex flex-col items-center justify-center py-16 text-slate-500 dark:text-slate-400">
                <span className="material-symbols-outlined text-7xl opacity-30 mb-4">info</span>
                <p className="text-lg font-medium">{emptyMessage}</p>
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                {items?.map((item, index) => (
                  <div
                    key={item.ShopDetailID || index}
                    className="bg-slate-50 dark:bg-slate-800/60 border border-slate-200 dark:border-slate-700 rounded-xl p-5 hover:shadow-lg hover:border-slate-300 dark:hover:border-slate-600 transition-all duration-200 group"
                  >
                    <div className="flex justify-between items-start mb-3">
                      <h3 className="font-semibold text-slate-900 dark:text-white text-base leading-tight pr-10 line-clamp-2">{item.ShopName || "Unnamed Shop"}</h3>
                      <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300 shrink-0">#{index + 1}</span>
                    </div>

                    <div className="flex items-center gap-1.5 text-sm text-slate-600 dark:text-slate-400 mb-2">
                      <span className="material-symbols-outlined text-base">location_on</span>
                      {item.AreaName || "—"}
                    </div>

                    {(item.ShopOpenTime || item.ShopCloseTime) && (
                      <div className="flex items-center gap-1.5 text-sm text-slate-600 dark:text-slate-400 mb-3">
                        <span className="material-symbols-outlined text-base">schedule</span>
                        {item.ShopOpenTime || "--:--"} – {item.ShopCloseTime || "--:--"}
                      </div>
                    )}

                    <p className="text-sm text-slate-500 dark:text-slate-400 line-clamp-2 mb-3">{item.Address || "No address available"}</p>

                    {item.ShopMobileNo1 && (
                      <div className="text-sm">
                        <span className="font-medium text-slate-700 dark:text-slate-300">Contact: </span>
                        <a href={`tel:${item.ShopMobileNo1}`} className="text-blue-600 dark:text-blue-400 hover:underline">
                          {item.ShopMobileNo1}
                        </a>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Footer */}
          <div className="px-6 py-4 border-t border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-950/50 flex justify-end">
            <button
              onClick={onClose}
              className="px-8 py-2.5 bg-slate-200 dark:bg-slate-700 hover:bg-slate-300 dark:hover:bg-slate-600 text-slate-800 dark:text-slate-200 rounded-lg font-medium transition-colors"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  };

  if (isLoading) {
    return <DashboardShimmer />;
  }

  const handleNavigate = (pathname) => {
    navigate(`/${mainRouteInitial}/${pathname}`, {
      state: {
        filterData: filterData,
      },
    });
  };
  console.log("sdfjsdkfjdsakjsaff", filterData);
  return (
    <main className="flex-1 overflow-y-auto p-3 md:px-8 scroll-smooth">
      <div className="mx-auto max-w-7xl flex flex-col gap-3">
        {/* Filters */}
        <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-sm border border-slate-200 dark:border-slate-800 ">
          {/* Header with toggle + reset */}
          <div className="px-6 py-0 border-b border-slate-200 dark:border-slate-800 flex items-center justify-between">
            <h2 className="text-lg font-semibold text-slate-900 dark:text-white flex items-center gap-2">
              <span className="material-symbols-outlined text-blue-600">filter_list</span>
              Filters
            </h2>

            <div className="flex items-center gap-2">
              {/* Collapse / Expand Button */}
              <button
                onClick={() => setIsFilterOpen((prev) => !prev)}
                title={isFilterOpen ? "Collapse filters" : "Expand filters"}
                className="p-2 rounded-full hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200"
              >
                <span className="material-symbols-outlined text-xl">{isFilterOpen ? "expand_less" : "expand_more"}</span>
              </button>

              {/* Reset Button */}
              <button
                onClick={handleReset}
                title="Reset all filters"
                className="p-2 rounded-full hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200"
              >
                <span className="material-symbols-outlined text-xl">restart_alt</span>
              </button>
            </div>
          </div>

          {/* Collapsible Content */}
          {isFilterOpen && (
            <div className="p-3 sm:p-6 animate-fade-in">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
                {/* Zone */}
                {(isCityLogin || isZoneLogin) && (
                  <div className="space-y-1.5">
                    <label className="text-sm font-medium text-slate-700 dark:text-slate-300">Zone</label>
                    <Select
                      options={[{ label: "All Zones", value: Cookies.get("NIGHT_EYE_ZONE_ID") || "" }, ...zoneOptions]}
                      value={zoneOptions.find((opt) => opt.value === filterData?.zoneID) || null}
                      onChange={(opt) => handleSelectFilterData("zoneID", opt?.value || "")}
                      placeholder="Select Zone"
                      styles={selectStyles}
                      // isDisabled={isZoneLogin && zoneOptions.length === 1}
                      classNamePrefix="react-select"
                    />
                  </div>
                )}

                {/* Police Station */}
                {(isCityLogin || isZoneLogin || isPSLogin) && (
                  <div className="space-y-1.5">
                    <label className="text-sm font-medium text-slate-700 dark:text-slate-300">Police Station</label>
                    <Select
                      options={[{ label: "All Stations", value: Cookies.get("NIGHT_EYE_POLICE_STATION_ID") || "" }, ...policeStationOptions]}
                      value={policeStationOptions.find((opt) => opt.value === filterData?.policeStationID) || null}
                      onChange={(opt) => handleSelectFilterData("policeStationID", opt?.value || "")}
                      placeholder="Select Police Station"
                      styles={selectStyles}
                      // isDisabled={isPSLogin && policeStationOptions.length === 1}
                      classNamePrefix="react-select"
                    />
                  </div>
                )}

                {/* Area */}
                {(isCityLogin || isZoneLogin || isPSLogin) && (
                  <div className="space-y-1.5">
                    <label className="text-sm font-medium text-slate-700 dark:text-slate-300">Area</label>
                    <Select
                      options={[{ label: "All Areas", value: Cookies.get("NIGHT_EYE_AREA_ID") || "" }, ...areaOptions]}
                      value={areaOptions?.find((opt) => opt.value === filterData?.areaID) || null}
                      onChange={(opt) => handleSelectFilterData("areaID", opt?.value || "")}
                      placeholder="Select Area"
                      styles={selectStyles}
                      classNamePrefix="react-select"
                    />
                  </div>
                )}

                {/* Date */}
                <div className="space-y-1.5">
                  <label className="text-sm font-medium text-slate-700 dark:text-slate-300">Date</label>
                  <div className="relative">
                    <Flatpickr
                      options={{ dateFormat: "d-m-Y" }}
                      value={filterData?.startDate}
                      className="w-full px-4 py-2.5 bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-600 rounded-xl text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                      onChange={(e) => handleSelectFilterData("startDate", e?.[0])}
                      placeholder="Select date"
                    />
                    <span className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none">
                      <span className="material-symbols-outlined">calendar_today</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Stats Cards - Row 1 */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {/* Overall Vendor */}
          <div
            onClick={() => handleNavigate("VendorList")}
            className="cursor-pointer flex flex-col gap-2 rounded-xl p-6 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-sm relative overflow-hidden group hover:shadow-md transition-shadow"
          >
            <div className="absolute right-0 top-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity">
              <span className="material-symbols-outlined text-blue-600" style={{ fontSize: 64 }}>
                storefront
              </span>
            </div>
            <p className="text-[#4c739a] dark:text-gray-400 text-sm font-semibold uppercase tracking-wider">Registered Vendors</p>
            <p className="text-[#0d141b] dark:text-white text-3xl font-bold leading-none">{departmentDashboardData?.[0]?.OverallVendor || "0"}</p>
          </div>

          {/* Open Shop */}
          <div
            onClick={() => handleNavigate("openShop")}
            className="cursor-pointer flex flex-col gap-2 rounded-xl p-6 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-sm relative overflow-hidden group hover:shadow-md transition-shadow"
          >
            <div className="absolute right-0 top-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity">
              <span className="material-symbols-outlined text-green-600" style={{ fontSize: 64 }}>
                check_circle
              </span>
            </div>
            <p className="text-[#4c739a] dark:text-gray-400 text-sm font-semibold uppercase tracking-wider">Not Made Entry</p>
            <p className="text-[#0d141b] dark:text-white text-3xl font-bold leading-none">{departmentDashboardData?.[0]?.OpenShop || "0"}</p>
          </div>

          {/* Close Shop */}
          <div
            onClick={() => handleNavigate("closeShop")}
            className="cursor-pointer flex flex-col gap-2 rounded-xl p-6 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-sm relative overflow-hidden group hover:shadow-md transition-shadow"
          >
            <div className="absolute right-0 top-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity">
              <span className="material-symbols-outlined text-orange-500" style={{ fontSize: 64 }}>
                pending
              </span>
            </div>
            <p className="text-[#4c739a] dark:text-gray-400 text-sm font-semibold uppercase tracking-wider">Shop Closed On Time</p>
            <p className="text-[#0d141b] dark:text-white text-3xl font-bold leading-none">{departmentDashboardData?.[0]?.CloseShop || "0"}</p>
          </div>

          {/* Late Close */}
          <div
            // onClick={() => {
            //   setModalType("LateCloseMoreThan2Times");
            //   setIsModalOpen(true);
            // }}  //11-02-2026
            onClick={() => handleNavigate("dailyClose")}
            className="cursor-pointer flex flex-col gap-2 rounded-xl p-6 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-sm relative overflow-hidden group hover:shadow-md transition-shadow"
          >
            <div className="absolute right-0 top-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity">
              <span className="material-symbols-outlined text-orange-600" style={{ fontSize: 64 }}>
                schedule
              </span>
            </div>

            <p className="text-[#4c739a] dark:text-gray-400 text-sm font-semibold uppercase tracking-wider">Shop Closed Late</p>
            {/* <p className="text-[#0d141b] dark:text-white text-3xl font-bold leading-none">{departmentDashboardData?.[0]?.LateCloseMoreThan2Times || "0"}</p> //11-02-2026 */}

            {/* 11-02-2026 */}
            <p className="text-[#0d141b] dark:text-white text-3xl font-bold leading-none">{departmentDashboardData?.[0]?.ShopLateClosure || "0"}</p>

            {/* <p className="text-xs text-slate-500 dark:text-slate-400 mt-1 font-medium">Based on last 7 days data</p> */}
            {/* ← Added time-period label */}
          </div>
        </div>
        {/* Stats Cards - Row 2 (with modals) */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {/* Active Violations */}
          <div
            onClick={() => handleNavigate("violations")}
            className="cursor-pointer flex flex-col gap-2 rounded-xl p-6 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-sm relative overflow-hidden group hover:shadow-md transition-shadow"
          >
            <div className="absolute right-0 top-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity">
              <span className="material-symbols-outlined text-red-600" style={{ fontSize: 64 }}>
                warning
              </span>
            </div>
            <p className="text-[#4c739a] dark:text-gray-400 text-sm font-semibold uppercase tracking-wider">Violations Reported</p>
            <p className="text-[#0d141b] dark:text-white text-3xl font-bold leading-none">{departmentDashboardData?.[0]?.ActiveViolations || "0"}</p>
          </div>

          {/* Shop Not Operating */}
          <div
            onClick={() => handleNavigate("shopNotOperate")}
            className="cursor-pointer flex flex-col gap-2 rounded-xl p-6 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-sm relative overflow-hidden group hover:shadow-md transition-shadow"
          >
            <div className="absolute right-0 top-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity">
              <span className="material-symbols-outlined text-red-600" style={{ fontSize: 64 }}>
                store
              </span>
            </div>

            <p className="text-[#4c739a] dark:text-gray-400 text-sm font-semibold uppercase tracking-wider">In Active Users</p>

            <p className="text-[#0d141b] dark:text-white text-3xl font-bold leading-none">{departmentDashboardData?.[0]?.NotOperateSystem || "0"}</p>

            <p className="text-xs text-slate-500 dark:text-slate-400 mt-1 font-medium">Based on last 7 days data</p>

            {/* ← Added time-period label */}
          </div>

          {/* No CCTV */}
          <div
            onClick={() => {
              setModalType("NoCCTV");
              setIsModalOpen(true);
            }}
            className="cursor-pointer flex flex-col gap-2 rounded-xl p-6 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-sm relative overflow-hidden group hover:shadow-md transition-shadow"
          >
            <div className="absolute right-0 top-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity">
              <span className="material-symbols-outlined text-amber-600" style={{ fontSize: 64 }}>
                videocam_off
              </span>
            </div>
            <p className="text-[#4c739a] dark:text-gray-400 text-sm font-semibold uppercase tracking-wider">No CCTV Installed</p>
            <p className="text-[#0d141b] dark:text-white text-3xl font-bold leading-none">{departmentDashboardData?.[0]?.NoCCTV || "0"}</p>
          </div>

          {/* No Shop Agreement */}
          <div
            onClick={() => {
              setModalType("NoShopAgreement");
              setIsModalOpen(true);
            }}
            className="cursor-pointer flex flex-col gap-2 rounded-xl p-6 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-sm relative overflow-hidden group hover:shadow-md transition-shadow"
          >
            <div className="absolute right-0 top-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity">
              <span className="material-symbols-outlined text-purple-600" style={{ fontSize: 64 }}>
                description
              </span>
            </div>
            <p className="text-[#4c739a] dark:text-gray-400 text-sm font-semibold uppercase tracking-wider">No Rent Agreement</p>
            <p className="text-[#0d141b] dark:text-white text-3xl font-bold leading-none">{departmentDashboardData?.[0]?.NoShopAgreement || "0"}</p>
          </div>
        </div>

        {/* Map + Recent Violations */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 h-[600px] min-h-[500px]">
          <DashboardMapPreview departmentDashboardData={departmentDashboardData} />

          <div className="lg:col-span-1 flex flex-col rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 overflow-hidden shadow-sm h-full">
            <div className="p-4 border-b border-slate-100 dark:border-slate-700 flex justify-between items-center bg-slate-50/50 dark:bg-slate-800/50">
              <h3 className="font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
                <span className="material-symbols-outlined text-red-500">warning</span>
                Recent Violations Reported by Officer
              </h3>
            </div>
            <div className="flex-1 overflow-y-auto">
              {departmentDashboardData?.[0]?.ActiveViolationsData?.map((ele, idx) => (
                <div key={idx} className="p-4 border-b border-slate-100 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700/50 transition-colors">
                  <h4 className="text-sm font-bold text-slate-900 dark:text-white">{ele.ShopName}</h4>
                  <div className="flex items-center gap-1 text-xs text-slate-500 dark:text-slate-400 my-1">
                    <span className="material-symbols-outlined text-[14px]">location_on</span>
                    {ele.AreaName}
                  </div>
                  <p className="text-sm text-slate-700 dark:text-slate-300">{ele.Description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-lg border border-slate-200/80 dark:border-slate-700/50 overflow-hidden">
          <table className="min-w-full divide-y divide-slate-200 dark:divide-slate-700">
            <thead className="bg-slate-50 dark:bg-slate-800/50 sticky top-0 z-10">
              <tr>
                <th className="py-4 pl-6 pr-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">Sr No</th>
                <th className="py-4 px-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">Police Station</th>
                <th className="py-4 px-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">Registered Vendors</th>
                <th className="py-4 px-3 pl-6 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">Not Made Entry</th>
                <th className="py-4 px-3 pl-6 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">Shop Closed</th>
                <th className="py-4 px-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">Violations Reported</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200 dark:divide-slate-700">
              {departmentDashboardData?.[0]?.PoliceStationWiseData?.map((shop, idx) => {
                return (
                  <>
                    <tr key={idx} className="hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors">
                      <td className=" py-4 pl-4 pr-3 text-sm font-medium text-slate-900 dark:text-white sm:pl-6">{idx + 1}</td>
                      <td className=" py-4 pl-4 pr-3 text-sm font-medium text-slate-900 dark:text-white sm:pl-6">
                        <div className="flex flex-col">
                          <p className="text-[#0d141b] dark:text-white font-bold text-base">{shop?.PoliceStation || "0"}</p>
                        </div>
                      </td>
                      <td className=" px-3 py-4 text-sm text-slate-500 dark:text-slate-400">
                        <p className="text-sm text-[#4c739a] dark:text-gray-200">{shop?.OverallShop || "0"}</p>
                      </td>
                      <td className=" px-3 py-4 text-sm text-slate-500 dark:text-slate-400">
                        <p className="text-sm text-[#4c739a] dark:text-gray-200">{shop?.OpenShop || "0"}</p>
                      </td>
                      <td className=" px-3 py-4 text-sm text-slate-500 dark:text-slate-400">
                        <p className="text-sm text-[#4c739a] dark:text-gray-200">{shop?.CloseShop || "0"}</p>
                      </td>
                      <td className=" px-3 py-4 text-sm text-slate-500 dark:text-slate-400">
                        <p className="text-sm text-[#4c739a] dark:text-gray-200">{shop?.ActiveViolations || "0"}</p>
                      </td>
                    </tr>
                  </>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* Modal */}
        <DetailModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          title={
            modalType === "NoCCTV"
              ? "Shops with No CCTV Installed"
              : modalType === "NoShopAgreement"
                ? "Shops without Rent Agreement"
                : "Shops with Repeated Late Closure (More than 2 times)"
          }
          icon={modalType === "NoCCTV" ? "videocam_off" : modalType === "NoShopAgreement" ? "description" : "schedule"}
          color={
            modalType === "NoCCTV"
              ? "bg-amber-50 dark:bg-amber-950/20"
              : modalType === "NoShopAgreement"
                ? "bg-purple-50 dark:bg-purple-950/20"
                : "bg-orange-50 dark:bg-orange-950/20"
          }
          items={modalType === "NoCCTV" ? detailDashboardData || [] : modalType === "NoShopAgreement" ? detailDashboardData || [] : detailDashboardData || []}
          emptyMessage="No matching records found for the selected filters."
        />
      </div>
    </main>
  );
};

export default ComplianceDashboard;
